import { render, staticRenderFns } from "./WithoutAlertsRoutingStatus.vue?vue&type=template&id=9b15545c&scoped=true&"
import script from "./WithoutAlertsRoutingStatus.vue?vue&type=script&lang=js&"
export * from "./WithoutAlertsRoutingStatus.vue?vue&type=script&lang=js&"
import style0 from "./WithoutAlertsRoutingStatus.vue?vue&type=style&index=0&id=9b15545c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b15545c",
  null
  
)

export default component.exports